import React, { ComponentProps } from 'react'
import { IconRegularError } from '@notino/react-styleguide'

// hooks
import useMessages from '../../hooks/useMessages'

// components
import Empty from '../Empty/Empty'

type Props = Omit<ComponentProps<typeof Empty>, 'button'> & {
	button?: { label?: string; href?: string; onClick?: (e: React.SyntheticEvent<HTMLElement>) => void; isLoading?: boolean }
	className?: string
}

const ErrorScreen = (props: Props) => {
	const { label, title, icon = <IconRegularError color={'icon.disabled'} />, minHeight = '300px', maxWidth, button, ...restProps } = props
	const { messages } = useMessages()

	return (
		<Empty
			{...restProps}
			icon={icon}
			title={title || messages['Something went wrong. Data was not loaded.']}
			label={label}
			minHeight={minHeight}
			maxWidth={maxWidth}
			button={
				button ? { label: button.label || messages['Try again'], onClick: button.onClick, href: button.href, isLoading: button.isLoading } : undefined
			}
		/>
	)
}

export default ErrorScreen
